import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import LoaderPage from "./components/utils/LoaderPage";
import mainStore from "./store/index";

function PrivateRoute({ children }) {
  const STORE = mainStore();

  const [userlogged, setuserlogged] = useState(null);
  const [isloader, setLoader] = useState(true);

  useEffect(() => {
    handleLoged();
  }, []);

  const handleLoged = async () => {
    setLoader(true);
    let logged = await STORE.handleUserlogged();
    setuserlogged(logged);

    setLoader(false);
  };

  return isloader ? (
    <LoaderPage />
  ) : userlogged ? (
    children
  ) : (
    <Navigate to="/login" />
  );
}


export default PrivateRoute;
